import React from 'react';
import { Link } from 'react-router-dom';

const InquiryBtn = ({ text, path }) => {
  
  const ListBtnDiv = {
    fontSize: '19px',
    width: '155px',
    height: '40px',
    backgroundColor: 'rgba(62, 28, 106, 0.90)',
    color: '#FFF',
    fontWeight: '400',
    padding: '5px',
  };

  return (
    <Link to={path} className='text-line-none center'>
      <div style={ListBtnDiv}>
        {text}
      </div>
    </Link>
  );
}

export default InquiryBtn;
